import React, { useEffect } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { useSelector } from 'react-redux';
import { isLiabilitiesValue } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgets.types';
import { renderWidgets } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgets.helpers';

export const LiabilitiesWidgets = observer('LiabilitiesWidgets', () => {
    const appState = useAppStateContext();
    const {
        routerBackoffice,
        reduxAction: { onGetLiabilitiesRequest, onRemoveLiabilitiesRequest }
    } = useAppStateContext();

    //@ts-expect-error
    const liabilitiesProps = useSelector((state) => state.liabilities);

    const liabilities = liabilitiesProps.get('items');

    //add liabilities from the url by the eventId and marketId
    useEffect(() => {
        const eventId = routerBackoffice.getParametersNumber(
            'liabilities',
            'event'
        );
        const marketId = routerBackoffice.getParametersNumber(
            'liabilities',
            'market'
        );
        const value = routerBackoffice.getValueString('liabilities');

        if (eventId === null || marketId === null || value === null) {
            console.error('Cant get liabilities by IDs');
        } else {
            const marketIdNew = appState.sdkStaff.models.id.getEventId(eventId).getMarketId(marketId);
            if (isLiabilitiesValue(value)) {
                onGetLiabilitiesRequest(
                    marketIdNew,
                    value
                );
            } else {
                console.error('Liabilities value is not the type as expect');
            }
        }
    }, []);

    return (
        <div className='liabilities-widgets-list'>
            {renderWidgets(liabilities, onRemoveLiabilitiesRequest)}
        </div>
    );
});
